import { createSlice } from '@reduxjs/toolkit';
import { getScheduledBatch } from 'ducks/scheduled-batch/operators';
import { Slices } from 'ducks/slices';
import { ScheduledBatch } from 'ducks/types/store-types';
import { NullableNumberInterface } from 'ducks/types/type-helpers';
import { normalizeBatchDefinition, normalizeScheduledBatch } from 'ducks/utils';

export type ScheduledBatchState = NullableNumberInterface<ScheduledBatch>;

const initialState: ScheduledBatchState = {
  scheduled_batch_id: null,
  project_id: null,
  project_name: '',
  organization_id: null,
  organization_name: '',
  scheduled_batch_name: '',
  batch_definition_id: null,
  batch_definition_name: '',
  interval_id: null,
  interval_name: '',
  interval_frequency: null,
  interval_bitmask: '0000000',
  start_datetime_utc: '',
  finish_datetime_utc: '',
  is_active: false,
  next_datetime_utc: '',
  last_datetime_utc: '',
  last_batch_id: null,
  created_by: '',
  created_datetime_utc: '',
  is_archived: false,
  sort_datetime_utc: '',
  timeout_seconds_masked: '',
  start_datetime_utc_slim: '',
  start_datetime_utc_sort: '',
  start_datetime_utc_formatted: '',
  start_datetime_slim: '',
  start_datetime_sort: '',
  start_datetime_formatted: '',
  last_datetime_utc_sort: '',
  last_datetime_utc_formatted: '',
  last_datetime_sort: '',
  last_datetime_formatted: '',
  next_datetime_utc_slim: '',
  next_datetime_utc_sort: '',
  next_datetime_utc_formatted: '',
  next_datetime_slim: '',
  next_datetime_sort: '',
  next_datetime_formatted: '',
  finish_datetime_utc_formatted: '',
  finish_datetime_formatted: '',
  created_datetime_formatted: '',
  created_datetime_utc_formatted: '',
  uuid: '',
  modified: false,
};

const scheduledBatchSlice = createSlice({
  name: Slices.SCHEDULED_BATCH,
  initialState,
  reducers: {
    setScheduledBatch: (state, { payload }) => {
      const batch = normalizeBatchDefinition(payload);
      return { ...state, ...batch };
    },
    clearScheduledBatch: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledBatch.pending, () => {
        return initialState;
      })
      .addCase(getScheduledBatch.fulfilled, (state, { payload }) => {
        const batch = normalizeScheduledBatch(payload);
        return { ...state, ...batch };
      })
      .addCase(getScheduledBatch.rejected, () => {
        return initialState;
      });
  },
});

export const { setScheduledBatch, clearScheduledBatch } = scheduledBatchSlice.actions;

export default scheduledBatchSlice.reducer;
